export const StoreRoutes = {
    ROOT: "/store",
    IMAGE_TEST: "/store/image-test",
    ERROR: "/store/error",
};


// WEBPACK FOOTER //
// ./src/components/store/StoreRoutes.tsx